import { Menu, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import { FaChevronDown } from 'react-icons/fa'
import { SiMicrosoftexcel } from 'react-icons/si'

const EXPORT_SUPPORT_FILES = [
  {
    name: 'Excel',
    icon: SiMicrosoftexcel,
    color: 'text-green-600',
  },
]

interface ExportAsProps {
  onExportAs: (type: string) => void;
}

export default function ExportAsButton({
  onExportAs,
} : ExportAsProps) {
  return (
    <Menu as="div" className="relative inline-block w-full text-left md:w-fit">
      <div>
        <Menu.Button className="inline-flex justify-center items-center w-full px-4 py-2.5 text-sm font-medium text-header border border-[#CCCCCC] bg-white rounded-md hover:bg-header/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75">
          Export As
          <FaChevronDown
            className="ml-2 -mr-1"
            aria-hidden="true"
          />
        </Menu.Button>
      </div>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-50 w-40 mt-2 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black/5 focus:outline-none">
          <div className="px-1 py-1 ">
            {EXPORT_SUPPORT_FILES.map(file => 
            <Menu.Item>
              {({ active }) => (
                <button
                  className={`${
                    active ? 'bg-gray-200' : 'text-gray-600'
                  } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                  onClick={() => onExportAs(file.name)}
                >
                  {<file.icon
                    className={`w-5 h-5 mr-2 ${file.color}`}
                    aria-hidden="true"
                  />}
                  {file.name}
                </button>
              )}
            </Menu.Item>
            )}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}
